/* DW-START — Dazzle Wears Custom Review System v1.7 (auto-opens write-review popup from email link via ?write_review=1, fixing the dead #dw-reviews-anchor that never matched any real element) */
(function(){
  if(window.__dwNewReviews)return;
  window.__dwNewReviews=true;

  var WORKER_URL = 'https://dw-reviews-worker.charlesudeh4real.workers.dev';

  function injectCSS(){
    if(document.getElementById('dw-nr-css'))return;
    var css=`
.dw-nr-badge{display:flex;align-items:center;gap:7px;font-family:'Helvetica Neue',sans-serif;font-size:13px;color:#888;cursor:pointer;width:fit-content;margin-bottom:14px}
.dw-nr-badge:hover{color:#c9a96e}
.dw-nr-badge .dw-nr-stars{color:#c9a96e;font-size:14px;letter-spacing:1px}
.dw-nr-summary{background:#f9f5f0;padding:26px 20px;border:1px solid #ece8e1;font-family:'Helvetica Neue',sans-serif;margin:20px 0}
.dw-nr-summary-top{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:16px;margin-bottom:20px}
.dw-nr-score-block{display:flex;align-items:center;gap:16px}
.dw-nr-score-num{font-family:Georgia,serif;font-size:34px;font-weight:400;color:#1a1a1a;line-height:1}
.dw-nr-score-meta .dw-nr-stars{color:#c9a96e;font-size:15px;letter-spacing:1px;display:block;margin-bottom:2px}
.dw-nr-score-meta .dw-nr-count{font-size:11px;color:#999}
.dw-nr-write-btn{background:#1a1a1a;color:#fff;border:none;padding:11px 22px;font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;transition:background .2s;white-space:nowrap}
.dw-nr-write-btn:hover{background:#c9a96e}
.dw-nr-slider{overflow:hidden;position:relative;transition:height .35s ease}
.dw-nr-track{display:flex;gap:10px;transition:transform .35s ease;align-items:flex-start}
.dw-nr-card{background:#fff;border:1px solid #ece8e1;padding:14px;min-width:0;flex-shrink:0;box-sizing:border-box}
.dw-nr-card-stars{color:#c9a96e;font-size:11px;letter-spacing:1px;margin-bottom:8px}
.dw-nr-card-photo{width:64px;height:64px;object-fit:cover;border-radius:2px;margin-bottom:10px;display:block;background:#f4f0ea;border:1px solid #ece8e1}
.dw-nr-card-text{font-size:12px;color:#555;font-style:italic;line-height:1.7;margin-bottom:10px}
.dw-nr-card-foot{display:flex;justify-content:space-between;align-items:center}
.dw-nr-card-author{font-size:10px;color:#aaa;letter-spacing:.06em;text-transform:uppercase}
.dw-nr-card-verified{font-size:9px;color:#c9a96e;letter-spacing:.05em;text-transform:uppercase}
.dw-nr-nav{display:flex;justify-content:center;gap:10px;margin-top:14px}
.dw-nr-nav-btn{width:34px;height:34px;border:1px solid #ddd;background:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:14px;color:#666;transition:all .2s}
.dw-nr-nav-btn:hover{border-color:#c9a96e;background:#f9f5f0}
.dw-nr-empty{font-size:12px;color:#888;text-align:center;padding:22px 0;font-style:italic}
@media(max-width:680px){.dw-nr-card{min-width:calc(85% - 5px)}}
.dw-nr-overlay{position:fixed;inset:0;background:rgba(26,26,26,.5);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;visibility:hidden;transition:opacity .25s,visibility .25s}
.dw-nr-overlay.dw-open{opacity:1;visibility:visible}
.dw-nr-popup{background:#fff;max-width:460px;width:100%;max-height:88vh;overflow:auto;font-family:'Helvetica Neue',sans-serif}
.dw-nr-popup-head{background:#f9f5f0;padding:20px 24px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #ece8e1}
.dw-nr-popup-title{font-family:Georgia,serif;font-size:19px;font-weight:400;color:#1a1a1a}
.dw-nr-popup-close{width:28px;height:28px;border-radius:50%;border:1px solid #ddd;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#888;font-size:14px}
.dw-nr-popup-close:hover{color:#1a1a1a;border-color:#c9a96e}
.dw-nr-popup-body{padding:22px 24px}
.dw-nr-field{margin-bottom:16px}
.dw-nr-label{display:block;font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#1a1a1a;margin-bottom:6px}
.dw-nr-label .dw-nr-opt{color:#bbb;font-weight:400;text-transform:none;letter-spacing:0}
.dw-nr-field-sub{font-size:10px;color:#aaa;margin-top:4px}
.dw-nr-input,.dw-nr-textarea{width:100%;border:1px solid #ece8e1;padding:10px 13px;font-family:'Helvetica Neue',sans-serif;font-size:13px;color:#1a1a1a;outline:none;box-sizing:border-box}
.dw-nr-input:focus,.dw-nr-textarea:focus{border-color:#c9a96e}
.dw-nr-textarea{resize:vertical;min-height:90px}
.dw-nr-star-picker{display:flex;gap:4px;font-size:24px;color:#ddd;cursor:pointer}
.dw-nr-star-picker span{transition:color .1s}
.dw-nr-star-picker span.dw-nr-on{color:#c9a96e}
.dw-nr-submit{width:100%;background:#1a1a1a;color:#fff;border:none;padding:14px;font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;margin-top:4px}
.dw-nr-submit:hover{background:#c9a96e}
.dw-nr-submit:disabled{background:#ccc;cursor:not-allowed}
.dw-nr-photo-zone{border:1.5px dashed #c9a96e;background:#f9f5f0;padding:16px;text-align:center;cursor:pointer}
.dw-nr-photo-zone strong{display:block;font-size:12px;color:#1a1a1a;margin-bottom:2px}
.dw-nr-photo-zone span{font-size:11px;color:#888}
.dw-nr-photo-preview{display:flex;align-items:center;gap:10px;border:1px solid #ece8e1;padding:10px 12px}
.dw-nr-photo-preview img{width:44px;height:44px;object-fit:cover;border-radius:2px;flex-shrink:0}
.dw-nr-photo-preview span{flex:1;font-size:11px;color:#888}
.dw-nr-photo-preview button{background:none;border:none;color:#bbb;font-size:16px;cursor:pointer;padding:2px 6px}
.dw-nr-photo-preview button:hover{color:#1a1a1a}
.dw-nr-error{display:none;background:#fff2f0;border:1px solid #ffccc7;color:#cf1322;font-size:12px;padding:9px 13px;margin-top:8px}
.dw-nr-success{text-align:center;padding:30px 10px}
.dw-nr-success svg{width:40px;height:40px;fill:#c9a96e;margin-bottom:12px}
.dw-nr-success-title{font-family:Georgia,serif;font-size:18px;color:#1a1a1a;margin-bottom:6px}
.dw-nr-success-text{font-size:12px;color:#888}
`;
    var s=document.createElement('style');s.id='dw-nr-css';s.textContent=css;document.head.appendChild(s);
  }

  function starGlyphs(score){
    var n=Math.round(parseFloat(score)||0);
    if(n<0)n=0; if(n>5)n=5;
    var s='';for(var i=0;i<5;i++)s+=(i<n?'★':'☆');
    return s;
  }

  async function fetchReviews(productId){
    try{var r=await fetch(WORKER_URL+'/api/reviews?product_id='+encodeURIComponent(productId));return await r.json();}
    catch(e){return {reviews:[],summary:{average:0,count:0}};}
  }
  async function submitReview(payload){
    var r=await fetch(WORKER_URL+'/api/reviews',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
    var data=await r.json();
    if(!r.ok)throw new Error(data.error||'Could not submit review');
    return data;
  }

  function renderBadge(el,summary){
    if(!el)return;
    var stars=document.createElement('span');stars.className='dw-nr-stars';stars.textContent=starGlyphs(summary.average);
    var meta=document.createElement('span');
    meta.textContent=summary.count?(summary.average+' · '+summary.count+' review'+(summary.count===1?'':'s')):'No reviews yet';
    el.innerHTML='';el.appendChild(stars);el.appendChild(meta);
  }

  function buildCard(rv){
    var div=document.createElement('div');div.className='dw-nr-card';
    var stars=document.createElement('div');stars.className='dw-nr-card-stars';stars.textContent=starGlyphs(rv.rating);div.appendChild(stars);
    if(rv.photo_url){
      var img=document.createElement('img');img.className='dw-nr-card-photo';img.src=rv.photo_url;img.alt='Customer photo';img.loading='lazy';
      div.appendChild(img);
    }
    var text=document.createElement('div');text.className='dw-nr-card-text';text.textContent='"'+rv.body+'"';div.appendChild(text);
    var foot=document.createElement('div');foot.className='dw-nr-card-foot';
    var author=document.createElement('span');author.className='dw-nr-card-author';author.textContent=rv.author_name;foot.appendChild(author);
    if(rv.verified_purchase){var v=document.createElement('span');v.className='dw-nr-card-verified';v.textContent='✓ Verified';foot.appendChild(v);}
    div.appendChild(foot);
    return div;
  }

  function setupSlider(wrap,cards){
    var sl=wrap.querySelector('.dw-nr-slider'),track=wrap.querySelector('.dw-nr-track');
    var prev=wrap.querySelector('.dw-nr-prev'),next=wrap.querySelector('.dw-nr-next');
    cards.forEach(function(c){track.appendChild(c);});
    var n=cards.length,idx=0;
    function vis(){var w=window.innerWidth;return w<=680?1:(w<=980?2:3);}
    function layout(){
      var v=vis(),w=sl.offsetWidth,cw=(w-10*(v-1))/v;
      cards.forEach(function(c){c.style.width=cw+'px';});
      var max=Math.max(0,n-v);
      if(idx>max)idx=max;
      track.style.transform='translateX(-'+(idx*(cw+10))+'px)';
      prev.style.opacity=idx<=0?'0.3':'1';
      next.style.opacity=idx>=max?'0.3':'1';
      var maxH=0;
      for(var i=idx;i<Math.min(idx+v,n);i++){if(cards[i].offsetHeight>maxH)maxH=cards[i].offsetHeight;}
      sl.style.height=maxH+'px';
    }
    prev.onclick=function(){idx=Math.max(0,idx-1);layout();};
    next.onclick=function(){var v=vis();idx=Math.min(Math.max(0,n-v),idx+1);layout();};
    window.addEventListener('resize',layout);
    layout();
  }

  function buildSummaryBlock(summary){
    var wrap=document.createElement('div');wrap.className='dw-nr-summary';

    var top=document.createElement('div');top.className='dw-nr-summary-top';

    var scoreBlock=document.createElement('div');scoreBlock.className='dw-nr-score-block';
    var scoreNum=document.createElement('div');scoreNum.className='dw-nr-score-num';scoreNum.textContent=summary.average||'0.0';
    var scoreMeta=document.createElement('div');scoreMeta.className='dw-nr-score-meta';
    var starsEl=document.createElement('span');starsEl.className='dw-nr-stars';starsEl.textContent=starGlyphs(summary.average);
    var countEl=document.createElement('span');countEl.className='dw-nr-count';countEl.textContent='Based on '+(summary.count||0)+' review'+(summary.count===1?'':'s');
    scoreMeta.appendChild(starsEl);scoreMeta.appendChild(countEl);
    scoreBlock.appendChild(scoreNum);scoreBlock.appendChild(scoreMeta);

    var writeBtn=document.createElement('button');writeBtn.type='button';writeBtn.className='dw-nr-write-btn';writeBtn.textContent='Write a Review';

    top.appendChild(scoreBlock);top.appendChild(writeBtn);
    wrap.appendChild(top);

    var slider=document.createElement('div');slider.className='dw-nr-slider';
    var trackWrap=document.createElement('div');trackWrap.className='dw-nr-track';
    slider.appendChild(trackWrap);
    wrap.appendChild(slider);

    var nav=document.createElement('div');nav.className='dw-nr-nav';
    var prevBtn=document.createElement('button');prevBtn.type='button';prevBtn.className='dw-nr-nav-btn dw-nr-prev';prevBtn.textContent='←';
    var nextBtn=document.createElement('button');nextBtn.type='button';nextBtn.className='dw-nr-nav-btn dw-nr-next';nextBtn.textContent='→';
    nav.appendChild(prevBtn);nav.appendChild(nextBtn);
    wrap.appendChild(nav);

    return wrap;
  }

  function showEmptyState(wrap){
    var sl=wrap.querySelector('.dw-nr-slider'),nav=wrap.querySelector('.dw-nr-nav');
    if(sl)sl.style.display='none';
    if(nav)nav.style.display='none';
    var empty=document.createElement('div');empty.className='dw-nr-empty';empty.textContent='Be the first to leave a review for this product.';
    wrap.insertBefore(empty,nav);
  }

  function openWritePopup(productId,productHandle,productTitle,onSuccess){
    var overlay=document.createElement('div');overlay.className='dw-nr-overlay';
    var popup=document.createElement('div');popup.className='dw-nr-popup';
    var rating=0;
    popup.innerHTML=
      '<div class="dw-nr-popup-head"><div class="dw-nr-popup-title">Write a Review</div><button type="button" class="dw-nr-popup-close">×</button></div>'
      +'<div class="dw-nr-popup-body">'
        +'<div class="dw-nr-field"><label class="dw-nr-label">Your Name</label><input class="dw-nr-input" id="dw-nr-name" placeholder="e.g. Sarah M."></div>'
        +'<div class="dw-nr-field"><label class="dw-nr-label">Email</label><input class="dw-nr-input" id="dw-nr-email" placeholder="you@example.com"><div class="dw-nr-field-sub">Used to verify your purchase — never shown publicly</div></div>'
        +'<div class="dw-nr-field"><label class="dw-nr-label">Your Rating</label><div class="dw-nr-star-picker" id="dw-nr-star-picker"><span data-v="1">★</span><span data-v="2">★</span><span data-v="3">★</span><span data-v="4">★</span><span data-v="5">★</span></div></div>'
        +'<div class="dw-nr-field"><label class="dw-nr-label">Your Review</label><textarea class="dw-nr-textarea" id="dw-nr-body" placeholder="Tell us what you think..."></textarea></div>'
        +'<div class="dw-nr-field"><label class="dw-nr-label">Photo <span class="dw-nr-opt">(optional)</span></label>'
          +'<div class="dw-nr-photo-zone" id="dw-nr-photo-zone"><strong>Add a photo</strong><span>JPG, PNG · Max 10MB</span></div>'
          +'<input type="file" id="dw-nr-photo-input" accept="image/*" style="display:none">'
          +'<div class="dw-nr-photo-preview" id="dw-nr-photo-preview" style="display:none"><img id="dw-nr-photo-img"><span id="dw-nr-photo-status"></span><button type="button" id="dw-nr-photo-remove">×</button></div>'
        +'</div>'
        +'<button type="button" class="dw-nr-submit" id="dw-nr-submit-btn">Submit Review</button>'
        +'<div class="dw-nr-error" id="dw-nr-error"></div>'
      +'</div>';
    overlay.appendChild(popup);document.body.appendChild(overlay);
    requestAnimationFrame(function(){overlay.classList.add('dw-open');});

    var photoUrl=null,photoFileId=null,photoUploading=false;
    var photoZone=popup.querySelector('#dw-nr-photo-zone');
    var photoInput=popup.querySelector('#dw-nr-photo-input');
    var photoPreview=popup.querySelector('#dw-nr-photo-preview');
    photoZone.onclick=function(){photoInput.click();};
    photoInput.onchange=function(){
      var f=photoInput.files[0];if(!f)return;
      var reader=new FileReader();
      reader.onload=function(e){popup.querySelector('#dw-nr-photo-img').src=e.target.result;};
      reader.readAsDataURL(f);
      photoZone.style.display='none';photoPreview.style.display='flex';
      popup.querySelector('#dw-nr-photo-status').textContent='Uploading…';
      photoUploading=true;photoUrl=null;photoFileId=null;
      var fd=new FormData();fd.append('file',f,f.name);fd.append('purpose','review');
      fetch(window.dwPhotoConnectorUrl||'https://dw-photo-connector.charlesudeh4real.workers.dev/',{method:'POST',body:fd})
        .then(function(r){return r.json();})
        .then(function(data){
          photoUploading=false;
          if(data&&data.url){photoUrl=data.url;photoFileId=data.fileId||null;popup.querySelector('#dw-nr-photo-status').textContent='Photo added ✓';}
          else{popup.querySelector('#dw-nr-photo-status').textContent='Upload failed';}
        })
        .catch(function(){photoUploading=false;popup.querySelector('#dw-nr-photo-status').textContent='Upload failed';});
    };
    popup.querySelector('#dw-nr-photo-remove').onclick=function(){
      photoInput.value='';photoUrl=null;photoFileId=null;photoUploading=false;
      photoZone.style.display='block';photoPreview.style.display='none';
    };

    var stars=popup.querySelectorAll('#dw-nr-star-picker span');
    stars.forEach(function(st){
      st.addEventListener('click',function(){
        rating=parseInt(st.dataset.v,10);
        stars.forEach(function(s2){s2.classList.toggle('dw-nr-on',parseInt(s2.dataset.v,10)<=rating);});
      });
    });

    function close(){overlay.classList.remove('dw-open');setTimeout(function(){if(overlay.parentNode)document.body.removeChild(overlay);},260);}
    popup.querySelector('.dw-nr-popup-close').onclick=close;
    overlay.addEventListener('click',function(e){if(e.target===overlay)close();});

    async function doSubmit(){
      var errEl=popup.querySelector('#dw-nr-error');
      var name=popup.querySelector('#dw-nr-name').value.trim();
      var email=popup.querySelector('#dw-nr-email').value.trim();
      var body=popup.querySelector('#dw-nr-body').value.trim();
      var btn=popup.querySelector('#dw-nr-submit-btn');
      btn.disabled=true;btn.textContent='Submitting…';
      try{
        var res=await submitReview({
          product_id:String(productId),product_handle:productHandle,
          rating:rating,review_body:body,author_name:name,author_email:email,
          photo_url:photoUrl||undefined,photo_file_id:photoFileId||undefined
        });
        var body2=popup.querySelector('.dw-nr-popup-body');
        body2.innerHTML='<div class="dw-nr-success"><svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>'
          +'<div class="dw-nr-success-title">'+(res.status==='approved'?'Review Published':'Thank You!')+'</div>'
          +'<div class="dw-nr-success-text">'+(res.status==='approved'?'Your review is now live on this page.':'Your review is pending approval and will appear shortly.')+'</div></div>';
        if(res.status==='approved'&&onSuccess){
          onSuccess({
            rating:rating,body:body,author_name:name,
            photo_url:photoUrl||null,verified_purchase:res.verified?1:0
          });
        }
        setTimeout(close,2200);
      }catch(e){
        errEl.textContent=e.message||'Something went wrong. Please try again.';
        errEl.style.display='block';
        btn.disabled=false;btn.textContent='Submit Review';
      }
    }

    popup.querySelector('#dw-nr-submit-btn').onclick=function(){
      var errEl=popup.querySelector('#dw-nr-error');errEl.style.display='none';
      var name=popup.querySelector('#dw-nr-name').value.trim();
      var email=popup.querySelector('#dw-nr-email').value.trim();
      var body=popup.querySelector('#dw-nr-body').value.trim();
      if(!name||!rating||!body||!email){
        errEl.textContent='Please add your name, email, a star rating, and a review.';
        errEl.style.display='block';return;
      }
      if(email.indexOf('@')===-1){
        errEl.textContent='Please enter a valid email address.';
        errEl.style.display='block';return;
      }
      var btn=popup.querySelector('#dw-nr-submit-btn');
      if(photoUploading){
        btn.disabled=true;btn.textContent='Uploading photo…';
        var waitTimer=setInterval(function(){
          if(!photoUploading){clearInterval(waitTimer);doSubmit();}
        },300);
        return;
      }
      doSubmit();
    };
  }

  async function init(){
    var root=document.getElementById('dw-new-reviews-root');
    if(!root)return;
    var productId=root.dataset.productId,productHandle=root.dataset.productHandle,productTitle=root.dataset.productTitle;
    injectCSS();
    var data=await fetchReviews(productId);
    var badge=document.getElementById('dw-new-rating-badge');
    renderBadge(badge,data.summary);
    if(badge)badge.addEventListener('click',function(){root.scrollIntoView({behavior:'smooth',block:'start'});});

    function renderAll(){
      root.innerHTML='';
      var wrap=buildSummaryBlock(data.summary);
      root.appendChild(wrap);
      var cards=(data.reviews||[]).map(buildCard);
      if(cards.length){setupSlider(wrap,cards);}else{showEmptyState(wrap);}
      wrap.querySelector('.dw-nr-write-btn').onclick=function(){
        openWritePopup(productId,productHandle,productTitle,function(newReview){
          data.reviews=[newReview].concat(data.reviews||[]);
          var oldCount=data.summary.count||0;
          var oldTotal=(data.summary.average||0)*oldCount;
          var newCount=oldCount+1;
          var newAverage=Math.round(((oldTotal+newReview.rating)/newCount)*10)/10;
          data.summary={
            average:newAverage,count:newCount,
            breakdown:Object.assign({},data.summary.breakdown,{
              [newReview.rating]:((data.summary.breakdown&&data.summary.breakdown[newReview.rating])||0)+1
            })
          };
          renderBadge(badge,data.summary);
          renderAll();
          fetchReviews(productId).then(function(fresh){data=fresh;});
        });
      };
    }
    renderAll();

    // DW-START — auto-open the write-review popup when arriving from the
    // post-purchase review-request email (?write_review=1), rather than just
    // scrolling to the section and leaving the customer to find the button.
    try{
      var params=new URLSearchParams(window.location.search);
      if(params.get('write_review')==='1'){
        root.scrollIntoView({behavior:'smooth',block:'start'});
        setTimeout(function(){
          var btn=root.querySelector('.dw-nr-write-btn');
          if(btn)btn.click();
        },450);
      }
    }catch(e){}
    // DW-END
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
/* DW-END */
